export default "__VITE_ASSET__6e84347a__"